import { render, staticRenderFns } from "./InsCmsCat11.vue?vue&type=template&id=ec53520a&scoped=true&"
import script from "./InsCmsCat11.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat11.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat11.vue?vue&type=style&index=0&id=ec53520a&lang=less&scoped=true&"
import style1 from "./InsCmsCat11.vue?vue&type=style&index=1&id=ec53520a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec53520a",
  null
  
)

export default component.exports